import { render } from "./edittable.vue?vue&type=template&id=520ce5c1"
import script from "./edittable.vue?vue&type=script&lang=js"
export * from "./edittable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__